<app-error-page
  [code]="404"
  [title]="'ERROR_PAGES.NOT_FOUND' | translate"
  [message]="'ERROR_PAGES.NOT_FOUND_MESSAGE' | translate"
  [mainPageBtn]="true"
  [backBtn]="true"
></app-error-page>
